export default "campaigns";
